import { useQuery } from '@tanstack/react-query';
import type { ChecklistView } from '@internal/backstage-plugin-bidone-backend';
import { UseQueryCustomResult } from '../../types';
import { useAuthedFetch } from '../useAuthedFetch';
import { RELEASES_KEY, TEMPLATE_BACKUPS_KEY, checklistKey } from './keys';

export const useReleases = (): UseQueryCustomResult<string[]> => {
  const authedFetch = useAuthedFetch();
  return useQuery({
    queryKey: RELEASES_KEY,
    queryFn: async () => authedFetch('/releases'),
  });
};

export const useReleaseChecklist = (
  release: string | null,
): UseQueryCustomResult<ChecklistView> => {
  const authedFetch = useAuthedFetch();
  return useQuery({
    queryKey: checklistKey(release ?? ''),
    queryFn: async () =>
      authedFetch(
        `/releases/${encodeURIComponent(release as string)}/checklist`,
      ),
    enabled: !!release,
  });
};

export interface DefaultTemplateBackup {
  partition: string;
  timestamp: string;
  items: number;
}

export const useDefaultTemplateBackups = (): UseQueryCustomResult<
  DefaultTemplateBackup[]
> => {
  const authedFetch = useAuthedFetch();
  return useQuery({
    queryKey: TEMPLATE_BACKUPS_KEY,
    queryFn: async () => authedFetch('/releases/default-template/backups'),
  });
};
